/**
 * Dev Mail - Purge Command
 * Delete all messages from an email account
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { confirm } from '@inquirer/prompts';
import { ConfigService } from '../../../services/config.service.js';
import { TempMailApiService } from '../../../services/temp-mail.service.js';

interface PurgeOptions {
    yes?: boolean;
    json?: boolean;
}

async function handlePurge(address: string, options: PurgeOptions): Promise<void> {
    const config = await new ConfigService().load();
    if (!config) {
        console.error('❌ Not initialized. Run "jai1 auth" first.');
        process.exit(1);
    }

    if (!options.yes && !options.json) {
        const confirmed = await confirm({
            message: `Xóa toàn bộ emails của ${chalk.cyan(address)}?`,
            default: false,
        });
        if (!confirmed) {
            console.log(chalk.dim('❌ Đã hủy.'));
            return;
        }
    }

    const api = new TempMailApiService(config);

    if (!options.json) {
        console.log(chalk.dim('⏳ Đang xóa tất cả emails...'));
    }

    const result = await api.purgeMessages(address);

    if (!result.success) {
        if (options.json) {
            console.log(JSON.stringify({ success: false, error: result.error }));
        } else {
            console.error(`❌ ${result.error}`);
        }
        process.exit(1);
    }

    if (options.json) {
        console.log(JSON.stringify({ success: true, data: result.data }));
        return;
    }

    const deleted = result.data?.deleted ?? 0;
    if (deleted === 0) {
        console.log(chalk.dim('Inbox đã trống, không có gì để xóa.'));
    } else {
        console.log(`✅ Đã xóa ${chalk.bold(deleted)} email.`);
    }
}

export function createMailPurgeCommand(): Command {
    return new Command('purge')
        .description('Xóa toàn bộ emails của một account')
        .argument('<address>', 'Địa chỉ email')
        .option('-y, --yes', 'Bỏ qua xác nhận')
        .option('-j, --json', 'Output dạng JSON')
        .addHelpText('after', `
Examples:
  $ j dev mail purge user@dollicons.com
  $ j dev mail purge user@dollicons.com -y
  $ j dev mail purge user@dollicons.com -j
`)
        .action(async (address: string, options: PurgeOptions) => {
            await handlePurge(address, options);
        });
}
